import {get,post,put} from '@/utils/request'
import {proxyHeader} from "@/utils/config"

//获取订单产品分类列表
export const getShopCarList = () => get(proxyHeader+'service/product-service/product-data/getProductDataType');

//获取产品列表
export const getProductList = p => post(proxyHeader+'service/product-service/product-data/queryList',p);

//审核产品列表
export const getApprovalList = p => post(proxyHeader+'service/product-service/product-data/approvalList',p);

//根据产品id查询产品详情
export const getProductDetail = p => get(proxyHeader+'service/product-service/product-data/info',p);

//根据数据联系人Id查询联系人信息
export const getProductContact = p => get(proxyHeader+'service/product-service/product-contact/queryByDataContact',p);

//产品评级获取接口
export const getProductLevel = p => get(proxyHeader+'service/product-service/product-level/productAvg',p);

//下载数据文件接口（附件信息）
export const getProductAppendix = p => get(proxyHeader+'service/product-service/product-data-attachment/queryByPdId',p);

//根据产品Id找产品文件数据
// export const getProductFile = p => get(proxyHeader+'service/product-service/product-data-file/list',p);
export const getProductFile = p => post(proxyHeader+'service/product-service/product-data-file/listWithDate',p);

//用户浏览数据接口
export const getProductBrowse = p => get(proxyHeader+'service/product-service/product-data/queryByUserFoot',p);

//根据产品Id获取用户下载数据接口
export const getUserDown = p => get(proxyHeader+'service/order-service/order/queryDownListByPdId', p);

//根据卫星数据获取自动运行算法数据范围
export const getRunDataBounds  = p => post('http://68wzu5cyfp.xuduan.vip/service/satellite-service/product-file/list',p);

//根据产品Id获取文件最近更新时间
export const getProductUpdateTime = p => get(proxyHeader+'service/product-service/product-data-file/getFileUpdateTime', p);

//根据产品Id获取产品详情数据时间
export const getProductDetailTime = p => get(proxyHeader+'service/product-service/product-data-file/getProductFileDate', p);

//根据产品Id获取文件大小
export const getProductFileSize = p => get(proxyHeader+'service/product-service/product-data-file/getProductFileSize', p);
//根据产品ID获取影像服务信息
export const getProductImageServiceInfo = p => get(proxyHeader+'service/product-service/product-data/getImagingByProductDataId', p);

//添加产品所有数据文件到购物车
export const addProductAllFileToCar = p => post(proxyHeader+'service/order-service/car/addCarAll',p);

//添加选择的数据文件到购物车
export const addCarForProduct = p => post(proxyHeader+'service/order-service/car/addCarForProduct',p);

//从ES查询卫星产品文件数据
export const getSatelliteFileData = p => post(proxyHeader+'service/product-service/satellite/querySatelliteFileByParam',p);

//申请运行 
export const ApplyForRun = p => post(proxyHeader+'service/product-service/product-data-file/applyCreateData',p);

//查询申请运行历史记录 
export const getRunRecord = p => get(proxyHeader+'service/product-service/product-data-apply/getByAppUserId',p);

//请运行数据生成订单 
export const ApplyRunOrder = p => post(proxyHeader+'service/order-service/order/createOrderForApply',p);



//我的产品上传模块*************************************************************************************************************

//我的产品列表 
export const getMyProductList = p => post(proxyHeader+'service/product-service/product-data/queryListPage',p);

//根据Id删除我的产品 
export const deleteMyProductSite = p => post(proxyHeader+'service/product-service/product-data/deleteMyProduct',p);

//新增产品 
export const addNewProdct = p => post(proxyHeader+'service/product-service/product-data/save',p);

//修改产品 
export const updateProduct = p => post(proxyHeader+'service/product-service/product-data/update',p);

//通过多个字典编码获取字典项 
export const getLikeByDicCodelist = p => post(proxyHeader+'service/common-service/sys-dic-item/likeByDicCodelist',p);

//产品详情 
export const queryProductInfo = p => get(proxyHeader+'service/product-service/product-data/queryInfo',p);

//产品联系人详情 
export const queryProductContactInfo = p => get(proxyHeader+'service/product-service/product-contact/info',p);

//产品订阅
export const addSubscribe = p => post(proxyHeader+'service/product-service/product-subscribe/subscribe',p);

//产品订阅列表
export const getSubscribeList = p => post(proxyHeader+'service/product-service/product-subscribe/list',p);

//取消订阅
export const cancelSubscribe = p => post(proxyHeader+'service/product-service/product-subscribe/cancleSubscribe',p);

//获取数据参数
export const getXQDataOption = p => get(proxyHeader+'service/product-service/iserver-map/getIserverMap',p);

//产品底图
export const getImagingGroup = p => get(proxyHeader+'service/product-service/product-data-imaging-res/imagingGroup',p);

//获取访问量
export const getProductDataGlanced  = p => get(proxyHeader+'service/product-service/product-data/getProductDataGlanced',p);

//获取边界
export const queryCoordinates  = p => get(proxyHeader+'service/product-service/product-data/queryCoordinates',p);

//获取边界
export const productApproval  = p => put(proxyHeader+'service/product-service/product-data/approval',p);

//产品收藏
export const addCollect = p => post(proxyHeader+'service/product-service/product-collect/collect',p);

//产品收藏列表
export const getCollectList = p => post(proxyHeader+'service/product-service/product-collect/list',p);

//取消收藏
export const cancelCollect = p => post(proxyHeader+'service/product-service/product-collect/cancleCollect',p);

//获取产品的图片集
export const getImageShowList = p => get(proxyHeader+'service/product-service/productPng/getPng',p);

//获取主题词
export const getDataTagByType = p => get(proxyHeader+'service/product-service/pdTypeTagsRel/getDataTagByType',p);

//获取FTP信息
export const getByUserFTP = p => get(proxyHeader+'service/product-service/productftp/getByLoginUser',p);
